import Phaser from 'phaser';
import { PlayerController } from '../Entities/PlayerController';
import { SaveManager } from './SaveManager';
import { AudioManager } from './AudioManager';

export interface CheckpointConfig {
  id: string;
  x: number;
  y: number;
}

export class CheckpointSystem {
  private scene: Phaser.Scene;
  private checkpoints: Map<string, Phaser.Physics.Arcade.Sprite> = new Map();
  private activeCheckpointId: string | null = null;

  constructor(scene: Phaser.Scene) {
    this.scene = scene;
  }

  public createCheckpoints(configs: CheckpointConfig[], group: Phaser.Physics.Arcade.StaticGroup): void {
    configs.forEach((cfg) => {
      const cp = group.create(cfg.x, cfg.y, 'checkpoint') as Phaser.Physics.Arcade.Sprite;
      cp.setDepth(20);
      cp.setData('cpId', cfg.id);
      this.checkpoints.set(cfg.id, cp);
    });
  }

  public handlePlayerOverlap(player: PlayerController, cpObj: Phaser.GameObjects.GameObject): void {
    const cpId = cpObj.getData('cpId') as string;
    if (this.activeCheckpointId === cpId) return;

    this.activeCheckpointId = cpId;
    const cp = this.checkpoints.get(cpId);

    if (cp) {
      AudioManager.playSFX('checkpoint');

      // Glow effect when activated
      this.scene.tweens.add({
        targets: cp,
        scaleX: 1.3,
        scaleY: 1.3,
        duration: 200,
        yoyo: true,
      });

      SaveManager.saveProgress({
        checkpointId: cpId,
        checkpointX: cp.x,
        checkpointY: cp.y - 10,
      });
    }
  }
}
